import { OrderContextType } from '@/types/IOrder'
import { createContext } from 'react'

export const OrderContext = createContext<OrderContextType | undefined>(
  undefined
)
